export type SeatLimitAction = "add-seats" | "contact-sales";

export const seatLimitAction = ({
  canPurchaseAdditionalSeats,
  isOwner,
}: {
  canPurchaseAdditionalSeats: boolean;
  isOwner: boolean;
}): SeatLimitAction =>
  canPurchaseAdditionalSeats && isOwner ? "add-seats" : "contact-sales";
